import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import HomeIcon from "./icons/HomeIcon";
import ServiceIcon from "./icons/ServicesIcon";
import ProfileIcon from "./icons/ProfileIcon";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const BottomNavigation = () => {
  const { t } = useTranslation();
  return (
    <div className="lg:hidden fixed bottom-2  w-full left-0 !z-[45] px-2">
      <div className="w-full flex py-2.5 justify-center items-center bg-white shadow-md rounded-xl">
        <BottomIcon icon={<HomeIcon className="bottom-icon" />} to={`/${i18next.language}/dashboard`} title={t("bottomNavigation.home")} />

        <BottomIcon icon={<ServiceIcon className="bottom-icon measure-icon" />} to={`/${i18next.language}/dashboard/services`} title={t("bottomNavigation.services")} />
        <BottomIcon icon={<ProfileIcon className="bottom-icon" />} to={`/${i18next.language}/dashboard/editProfile`} title={t("bottomNavigation.profile")} />
      </div>
    </div>
  );
};
type bottomIconProps = {
  to: string;
  icon: ReactNode;
  title?: string;
};
const BottomIcon = (props: bottomIconProps) => {
  const location = useLocation();

  const active = location.pathname === props.to;
  return (
    <Link className={`mx-5 flex justify-center items-center flex-col  ${active ? "active-icon" : "default-icon"}`} to={props.to}>
      {props.icon}
      <span className="mt-[2px] text-sm">{props.title}</span>
    </Link>
  );
};
export default BottomNavigation;
